var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJustMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4975 8.27932V8.32545C16.4758 12.1713 13.7257 15.3845 10.0881 16.1207C9.84149 16.1696 9.59208 16.2082 9.33796 16.2355C9.06314 16.2638 8.78266 16.2798 8.50031 16.2798C7.38972 16.2798 6.33184 16.0529 5.36996 15.6415L1.65889 16.0369C1.02548 16.1047 0.557727 15.4579 0.820315 14.878L1.81796 12.6684C0.986901 11.4078 0.502197 9.89862 0.502197 8.27932C0.502197 3.86955 4.0909 0.279785 8.50031 0.279785C12.6697 0.279785 16.1041 3.48826 16.4655 7.56664C16.4871 7.80012 16.4975 8.04019 16.4975 8.27932Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.345 5.94349C12.7036 5.64976 13.1959 6.08942 12.9436 6.47824L11.2646 9.06911L10.3761 10.4399C10.1869 10.7317 9.78975 10.8014 9.51211 10.5914L8.03917 9.47394L7.13093 8.78574C7.05752 8.7302 6.95493 8.73208 6.8834 8.79045L4.6547 10.6093C4.29611 10.9021 3.80482 10.4625 4.05706 10.0736L5.62976 7.64846L6.51822 6.27771C6.7074 5.98586 7.10458 5.91619 7.38223 6.12613L8.81187 7.20975L9.71916 7.89701C9.79351 7.95255 9.8961 7.95067 9.96763 7.8923L12.345 5.94255V5.94349Z",
    fill: "url(#paint0_linear_229_20551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_20551",
    x1: 5.1667,
    y1: 11.6393,
    x2: 11.8633,
    y2: 4.9447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0498FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C5EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F44E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8679"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustMessenger);
export default __webpack_public_path__ + "static/media/JustMessenger.ac313e426765b1acaa3a8a6c7d975e03.svg";
export { ForwardRef as ReactComponent };